// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._17o-f{padding-top:100px;margin:auto}.JPjuf{height:auto}h4{display:table-cell}table{margin-top:35px;width:90%}td{padding-bottom:15px}", ""]);
// Exports
exports.locals = {
	"root": "_17o-f",
	"container": "JPjuf"
};
module.exports = exports;
